import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "17.348",
  height: "17.348",
  x: ".826",
  y: ".826",
  fill: "#fff",
  rx: "8.674"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "17.348",
  height: "17.348",
  x: ".826",
  y: ".826",
  stroke: "#4C4DEE",
  "stroke-width": "1.652",
  rx: "8.674"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0004E7",
  d: "M8.762 10.459H5.075a.73.73 0 0 1-.526-.202.66.66 0 0 1-.212-.499.66.66 0 0 1 .212-.5.73.73 0 0 1 .526-.2h3.687V5.553a.66.66 0 0 1 .212-.5.73.73 0 0 1 .526-.2q.314 0 .525.2a.66.66 0 0 1 .213.5v3.503h3.688q.313 0 .525.202a.66.66 0 0 1 .212.5.66.66 0 0 1-.212.498.73.73 0 0 1-.526.202h-3.687v3.503a.66.66 0 0 1-.213.5.73.73 0 0 1-.525.201.73.73 0 0 1-.526-.201.66.66 0 0 1-.212-.5z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }